module.exports = __webpack_public_path__ + "img/gateaux.9485d8d4.png";